<template>
    <section class="contact-us">
       <AppContactHeader />
       <AppContactForm />
       <AppGoogleMap />
       <AppFooter />
    </section>
</template>

<script>
import AppContactHeader from '@/components/contact/Header';
import AppContactForm from '@/components/contact/ContactForm';
import AppGoogleMap from '@/components/contact/GoogleMap';
import AppFooter from '@/components/footer/Footer';

export default {
    name:'contact_us',
    components:{
      AppContactHeader,
      AppContactForm,
      AppGoogleMap,
      AppFooter
    }
}
</script>